__turbopack_context__.v({
  "brandFadeIn": "BrandNav-module__Bp61Pq__brandFadeIn",
  "brandMenuContainer": "BrandNav-module__Bp61Pq__brandMenuContainer",
  "brandMenuLink": "BrandNav-module__Bp61Pq__brandMenuLink",
  "brandMenuList": "BrandNav-module__Bp61Pq__brandMenuList",
  "visible": "BrandNav-module__Bp61Pq__visible",
});
